import CommentGroup from "./CommentGroup";
import LoadMoreComments from './LoadMoreComments'

import style from "./Comments.module.scss"
import { useComments } from "../hooks/useComments";

const Comments = () => {
  const {allIds} = useComments();

  return (
    <div className={style.comments}>
      {allIds.map((id) => (
        <div className={style.wrapper} key={id}>
          <CommentGroup id={id} />
        </div>
      ))}
      <LoadMoreComments className={style.more} />
    </div>
  );};

export default Comments;
